const testimonials = [
  {
    name: 'Marcus Chen',
    role: 'Active Shopper since 2023',
    text: 'The CSSBuy spreadsheet completely changed how I shop. I used to spend hours digging through random TaoBao links, but now everything is organized by category with working links and QC references. Absolute game-changer for building hauls efficiently.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20clean%20portrait%20photography%20of%20a%20young%20man%20in%20casual%20streetwear%20on%20a%20simple%20neutral%20cream%20background%20soft%20natural%20lighting%20editorial%20style%20with%20warm%20tones%20friendly%20confident%20expression%20minimal%20studio%20setup&width=200&height=200&seq=testimonial-01&orientation=squarish',
  },
  {
    name: 'Sarah Williams',
    role: 'Fashion Enthusiast',
    text: 'As someone new to agent shopping, the spreadsheet guide was incredibly helpful. The category breakdowns make it easy to find exactly what I want, and the sizing tips saved me from ordering the wrong sizes multiple times.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20clean%20portrait%20photography%20of%20a%20young%20woman%20in%20casual%20stylish%20outfit%20on%20a%20simple%20neutral%20cream%20background%20soft%20natural%20lighting%20editorial%20style%20with%20warm%20tones%20friendly%20genuine%20smile%20minimal%20studio%20setup&width=200&height=200&seq=testimonial-02&orientation=squarish',
  },
  {
    name: 'David Park',
    role: 'Sneaker Collector',
    text: 'I have tried at least five different spreadsheets, and this one is by far the most comprehensive. The shoes category alone has hundreds of verified links with actual QC photos. Highly recommend for anyone serious about their hauls.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20clean%20portrait%20photography%20of%20a%20young%20man%20in%20urban%20streetwear%20style%20on%20a%20simple%20neutral%20cream%20background%20soft%20natural%20lighting%20editorial%20style%20with%20warm%20tones%20confident%20expression%20minimal%20studio%20setup&width=200&height=200&seq=testimonial-03&orientation=squarish',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Budget Shopper',
    text: 'What I love most is how often the links are updated. Other spreadsheets I used would have half the links dead after a few weeks, but this CSSBuy spreadsheet stays fresh with daily updates. The best resource for budget finds hands down.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20clean%20portrait%20photography%20of%20a%20young%20woman%20in%20casual%20chic%20outfit%20on%20a%20simple%20neutral%20cream%20background%20soft%20natural%20lighting%20editorial%20style%20with%20warm%20tones%20genuine%20smile%20minimal%20studio%20setup&width=200&height=200&seq=testimonial-04&orientation=squarish',
  },
  {
    name: 'Alex Thompson',
    role: 'Community Contributor',
    text: 'The comparison tables and category organization make this spreadsheet stand out. I contribute finds regularly, and the community around this resource is genuinely helpful. If you are into agent shopping, this is an essential bookmark.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20clean%20portrait%20photography%20of%20a%20young%20man%20in%20modern%20casual%20style%20on%20a%20simple%20neutral%20cream%20background%20soft%20natural%20lighting%20editorial%20style%20with%20warm%20tones%20friendly%20smile%20minimal%20studio%20setup&width=200&height=200&seq=testimonial-05&orientation=squarish',
  },
];

export default function TestimonialSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-4 h-4 flex items-center justify-center text-accent-500">
              <i className="ri-star-fill text-xs"></i>
            </span>
            <span className="text-xs font-semibold uppercase tracking-widest text-foreground-500">
              Community
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            Trusted by Thousands
            <br />
            <span className="italic font-semibold">of Shoppers</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.slice(0, 3).map((t, i) => (
            <div key={i} className="bg-background-100 rounded-2xl p-6 md:p-7 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
              <div className="w-6 h-6 flex items-center justify-center text-accent-300 mb-3">
                <i className="ri-double-quotes-l text-xl"></i>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{t.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
          <div className="md:col-span-2 relative rounded-2xl overflow-hidden min-h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Lifestyle%20photography%20of%20diverse%20group%20of%20young%20people%20in%20casual%20trendy%20streetwear%20outfits%20posing%20together%20in%20a%20bright%20minimalist%20studio%20with%20warm%20natural%20light%20cream%20walls%20editorial%20fashion%20style%20with%20muted%20earthy%20tones%20sage%20olive%20beige%20and%20taupe%20color%20palette%20friendly%20atmosphere&width=900&height=400&seq=testimonial-wide-2026&orientation=landscape"
              alt="CSSBuy Spreadsheet community of shoppers"
              title="CSSBuy Spreadsheet Trusted Community"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 p-6 md:p-8">
              <div className="text-white font-semibold text-lg">{testimonials[3].name}</div>
              <div className="text-white/60 text-xs mb-2">{testimonials[3].role}</div>
              <p className="text-white/90 text-sm leading-relaxed max-w-md">{testimonials[3].text}</p>
            </div>
          </div>

          <div className="space-y-5">
            {testimonials.slice(4, 5).map((t, i) => (
              <div key={i} className="bg-background-100 rounded-2xl p-5 md:p-6">
                <div className="w-6 h-6 flex items-center justify-center text-accent-300 mb-2">
                  <i className="ri-double-quotes-l text-lg"></i>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{t.text}</p>
                <div className="flex items-center gap-3">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-9 h-9 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <div className="text-xs font-semibold text-foreground-950">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}